/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { parent_ParentWeekdayServicesDTO } from './parent_ParentWeekdayServicesDTO';
export type parent_ParentContractGroupSummaryDTO = {
    /**
     * AttendanceDaysPerWeek is the agreed number of days per week; null when unset.
     */
    attendanceDaysPerWeek?: number | null;
    /**
     * BillingCycle is the invoicing cycle.
     */
    billingCycle: parent_ParentContractGroupSummaryDTO.billingCycle;
    /**
     * ContractGroupID identifies the contract group across its versions.
     */
    contractGroupId: string;
    /**
     * ContractedWeekdays are the ISO weekdays of care (1..7).
     */
    contractedWeekdays: Array<number>;
    /**
     * EarliestTerminationDate is the earliest last day of care a termination sent
     * today can name: today (daycare time zone) plus noticePeriodDays (YYYY-MM-DD).
     * Null when the notice period is unknown or the contract is already terminated.
     * An earlier wish goes in the request comment for the office.
     */
    earliestTerminationDate?: string | null;
    /**
     * EndDate is the contract end (YYYY-MM-DD); null when open-ended.
     */
    endDate?: string | null;
    /**
     * NoticePeriodDays is the daycare's termination notice period in calendar days
     * (no end-of-month rounding); null when unknown.
     */
    noticePeriodDays?: number | null;
    /**
     * PlannedEndDate is the last day of care as planned today (YYYY-MM-DD): the
     * recorded termination date, else the contract end; null when open-ended.
     */
    plannedEndDate?: string | null;
    /**
     * ServicePattern lists the contracted services per weekday, sorted by weekday.
     */
    servicePattern: Array<parent_ParentWeekdayServicesDTO>;
    /**
     * StartDate is the contract start (YYYY-MM-DD).
     */
    startDate: string;
    /**
     * Status of the representative version. CANCELLED groups are never returned.
     */
    status: parent_ParentContractGroupSummaryDTO.status;
    /**
     * Subsidised reports whether the contract uses subsidised rates.
     */
    subsidised?: boolean;
    /**
     * TerminationDate is the notified termination date (YYYY-MM-DD); null when none.
     */
    terminationDate?: string | null;
};
export namespace parent_ParentContractGroupSummaryDTO {
    /**
     * BillingCycle is the invoicing cycle.
     */
    export enum billingCycle {
        MONTHLY = 'monthly',
        QUARTERLY = 'quarterly',
        YEARLY = 'yearly',
    }
    /**
     * Status of the representative version. CANCELLED groups are never returned.
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        TERMINATED = 'TERMINATED',
        UPCOMING = 'UPCOMING',
        ARCHIVED = 'ARCHIVED',
    }
}

